/** Keep HTML fallback pages and server diagnostics out of API consumers. */
export async function readApiResponse(response: Response): Promise<any> {
  if (!response.headers.get('content-type')?.includes('application/json')) {
    throw new Error('The server returned a webpage instead of account data. Please restart or update the server, then retry.');
  }
  return response.json();
}
